import { RouteTableColumn, RouteAnalysisRow } from '../route-function-report/route-analysis-report/route-analysis-report.models';
import { analysisSearch } from '../route-function-report/route-analysis-report/route-analysis-report.utils';
import { toEnglishDigits } from '../../report.utils';
export const GEOFENCE_SUMMARY_COLUMNS: RouteTableColumn[] = [
  { field: 'strGeoFenceName', title: 'مبدأ' }, { field: 'strNexFeoFenceName', title: 'مقصد' },
  { field: 'iCount', title: 'تعداد', numeric: true, totalField: 'iCount' },
  { field: 'strPresenceTime', title: 'سرجمع حضور در مبدأ', totalField: 'iPresenceTime', totalDuration: true },
  { field: 'strSumTime', title: 'مدت سفر', totalField: 'iSumTime', totalDuration: true },
  { field: 'strAverageTime', title: 'متوسط زمان سفر' },
  { field: 'fNavigation_km', title: 'سرجمع پیمایش (km)', numeric: true, totalField: 'fNavigation_km', unit: 'کیلومتر' },
  { field: 'iAverageSpeed', title: 'متوسط سرعت', numeric: true },
];
export function matchesGeofenceSummary(row: RouteAnalysisRow, query: string): boolean {
  const parts = query.split('-');
  if (parts.length > 1 && parts[1].trim()) return toEnglishDigits(String(row['strGeoFenceName'] ?? '')).toLowerCase().includes(parts[0].trim())
    && toEnglishDigits(String(row['strNexFeoFenceName'] ?? '')).toLowerCase().includes(parts[1].trim());
  return analysisSearch(row, GEOFENCE_SUMMARY_COLUMNS).includes(query);
}
export function numericSummaryUser(user: string): string | number {
  const value = parseFloat(user.replace(/,/g, '')); return isNaN(value) ? user : value;
}
